module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showCompanyOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Companies")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalCompanies))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-business",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCampaignOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Campaigns")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalCampaigns))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-stats",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showInfluencerOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Influencers")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalInfluencers))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-people",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showClientOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Clients")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalClients))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-contacts",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33efe870"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/KobeOverview.vue
// module id = 2072
// module chunks = 0